import React, { useEffect, useState } from "react";
import { baseUrl } from "../../../services/config";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import AddNotification from "./AddNotification";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import EditNotification from "./EditNotification";
import { useSelector } from "react-redux";
import { Pagination } from "@material-ui/lab";
import usePagination from "../../../components/usePagination/usePagination";
import { Table } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
const Notifications = () => {
  const initialFilter = {
    pageNumber: 1,
    pageSize: 10,
  };
  let authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  const [campusData, setCampusData] = useState(user.campuses || []);
  const [campusData2, setCampusData2] = useState([]);
  const [campusNotifications, setCampusNotifications] = useState([]);
  const [type, setType] = useState([]);
  const [campusId, setCampusId] = useState("");
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [loading, setloading] = useState(false);
  const [addModal, setaddModal] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedObject, setSelectedObject] = useState({});
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    getAllCampus();
    getAllType();
  }, []);

  const getAllCampus = () => {
    let arr = [];
    campusData.map((item) => {
      arr.push({ label: item.name, value: item.id });
    });
    setCampusData2(arr);
  };

  const getAllType = async () => {
    await fetch(`${baseUrl}/notification-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setType(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getNotifications = () => {
    setloading(true);
    setIsVisible(false);
    fetch(`${baseUrl}/notifications/campus/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        data.payload.forEach((item, i) => {
          item["sr_no"] = i + 1;
        });
        setCampusNotifications(data.payload);
        setloading(false);
        setIsVisible(true);
      })
      .catch((err) => {
        setloading(false);

        console.log("vehicle", err);
      });
  };

  const openEditCustomerDialog = (item) => {
    setSelectedObject(item);
    setEditModal(true);
  };

  const openDeleteCustomerDialog = (id) => {
    setSelectedId(id);
    setDeleteModalOpen(true);
  };

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(campusNotifications.length / PER_PAGE);
  const _DATA = usePagination(campusNotifications, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <>
      <Card style={{ marginTop: "10px", padding: 0 }}>
        <CardHeader title="Notifications list">
          <CardHeaderToolbar>
            <button
              onClick={() => {
                setaddModal(true);
              }}
              type="button"
              className="btn btn-primary"
            >
              New Notification
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <div className="container">
          <div className="row mt-2">
            <div className="col-sm-4">
              <label>
                <b>Select Campus</b>
              </label>
              <div className="d-flex flex-column">
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  aria-label="Default select example"
                  onChange={(e) => setCampusId(e.target.value)}
                >
                  <option selected value="">
                    {" "}
                    Select Campus
                  </option>
                  {campusData &&
                    campusData.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-md-2">
              <button
                disabled={loading}
                className="btn btn-primary mt-9"
                onClick={getNotifications}
              >
                Show
              </button>
            </div>
          </div>
        </div>
        <CardBody>
          {isVisible && (
            <Table responsive>
              <thead>
                <tr id="tbl">
                  <th className="text-center">Sr.No.</th>
                  <th className="text-center">Type</th>
                  <th className="text-center">Title</th>
                  <th className="text-start">Description</th>
                  <th className="text-center">Created At</th>
                  <th className="text-center">Edit</th>
                  <th className="text-center">Delete</th>
                </tr>
              </thead>

              <tbody>
                {_DATA.currentData().map((reportData, index) => {
                  return (
                    // key={index}
                    <tr key={index}>
                      <td className="text-center">{reportData?.sr_no}</td>
                      <td className="text-center">
                        {reportData?.notification_type?.name}
                      </td>
                      <td className="text-center">{reportData?.title}</td>
                      <td className="text-start">{reportData?.description}</td>
                      <td className="text-center">{reportData?.date_time}</td>
                      <td className="text-center">
                        <a
                          title="Edit"
                          className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                          onClick={() => openEditCustomerDialog(reportData)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Write.svg"
                              )}
                            />
                          </span>
                        </a>
                      </td>
                      <td className="text-center">
                        <a
                          title="Delete"
                          className="btn btn-icon btn-light btn-hover-danger btn-sm"
                          onClick={() =>
                            openDeleteCustomerDialog(reportData.id)
                          }
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg"
                              )}
                            />
                          </span>
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
          <div className="row justify-content-center">
            {loading && <span className="spinner-border"></span>}
          </div>

          <Pagination
            color="text-primary"
            count={count}
            size="large"
            page={page}
            variant="text"
            shape="round"
            onChange={handleChange}
          />
        </CardBody>
      </Card>

      <AddNotification
        reloader={getNotifications}
        type={type}
        campusData={campusData2}
        open={addModal}
        close={() => setaddModal(false)}
      />

      <EditNotification
        selected={selectedObject}
        reloader={getNotifications}
        type={type}
        campusData={campusData2}
        open={editModal}
        close={() => setEditModal(false)}
      />

      <DeleteModal
        visible={deleteModalOpen}
        HideModal={() => setDeleteModalOpen(false)}
        method={"DELETE"}
        url={`${baseUrl}/notifications/${selectedId}`}
        reload={getNotifications}
      />
    </>
  );
};

export default Notifications;
